import React from 'react';
import { Container } from 'reactstrap';
import OrderTransferDetailsView from './components/OrderTransferDetails';


const OrderTransferDetailsIndex = () => {  
  return (
    <Container>
    
      <OrderTransferDetailsView/>
     
    </Container>
  );
};

export default OrderTransferDetailsIndex;